import { useAuth } from '@on3/ui-lib/contexts/AuthProvider';
import clsx from 'clsx';

import styles from './Leader.module.scss';

interface IAdProps {
  id: string;
}

export const Leader = ({ id }: IAdProps) => {
  const { user } = useAuth();

  if (user?.st?.includes('premium')) {
    return null;
  }

  return <div className={clsx(styles.ad, 'leaderAd')} data-ui="ad" id={id} />;
};
